import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NumericInputDirective } from '../../../../directives/numeric-input.directive';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf, DecimalPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-add-offline-donation',
    templateUrl: './add-offline-donation.component.html',
    standalone: true,
    imports: [FlexModule, MatButtonModule, NgClass, ExtendedModule, MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NumericInputDirective, NgIf, TextFieldModule, DecimalPipe]
})
export class AddOfflineDonationComponent implements OnInit {
	addOfflineDonationForm!: UntypedFormGroup;
	currencyCode: string = '';
	maxTargetAmount: number = 999999;
	currencySymbol: string = '';

	constructor(
		public fundraiserService: FundraiserService,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			slug: string;
			currency_symbol: string;
			currency_code: string;
		},
		public dialogRef: MatDialogRef<AddOfflineDonationComponent>,
		public notificationService: NotificationService
	) {}

	ngOnInit(): void {
		this.currencyCode = this.data.currency_code;
		this.currencySymbol = this.data.currency_symbol;

		// GET MAX TARGET AMOUNT FOR SELECTED CURRENCY CODE
		this.fundraiserService
			.getMaxTargetAmountByCurrency(this.currencyCode)
			.subscribe((res: any) => {
				const targetAmountControl =
					this.addOfflineDonationForm.get('target_amount');

				this.maxTargetAmount =
					res?.data?.list_of_currencies[0]?.max_target_amount;
				// Update the max validator dynamically
				targetAmountControl?.setValidators([
					Validators.max(this.maxTargetAmount),
					Validators.pattern('^[0-9]+$'),
				]);
				// Trigger validation
				targetAmountControl?.updateValueAndValidity();
			});

		this.addOfflineDonationForm = new UntypedFormGroup({
			target_amount: new UntypedFormControl('', [
				Validators.max(this.maxTargetAmount),
				Validators.pattern('^[0-9]+$'),
			]),
			reason: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(15),
				Validators.maxLength(70),
			]),
		});
	}

	saveOfflineDonation() {
		this.addOfflineDonationForm.markAllAsTouched();
		const targetAmountControl =
			this.addOfflineDonationForm.get('target_amount');
		if (targetAmountControl?.value == 0) {
			targetAmountControl.setErrors({ greaterThanZero: true });
			return;
		}
		if (this.addOfflineDonationForm.valid) {
			let unlimited: boolean = false;
			let amount_target: string =
				this.addOfflineDonationForm.get('target_amount')?.value;
			if (
				amount_target == null ||
				amount_target == undefined ||
				amount_target.length <= 0 ||
				amount_target == '0'
			) {
				unlimited = true;
				amount_target = '0';
			}
			let addOfflineDonation: Object;
			addOfflineDonation = {
				currency: this.currencySymbol,
				//currency_code: this.currencyCode,
				amount: amount_target,
				description: this.addOfflineDonationForm.get('reason')?.value,
				slug: this.data.slug,
			};
			this.fundraiserService
				.createOfflineDonation(addOfflineDonation)
				.subscribe((response: any) => {
					this.fundraiserService.setOfflineDonation();
					this.notificationService.openNotification(
						$localize`:@@background_image_fundraiserBackground_notification: Save successful.`,
						'OK',
						'success'
					);
				},
				(error) => {
					this.notificationService.openNotification(
					  $localize`:@@background_image_fundraiserBackground_error:An error occurred while saving the background image.`,
					  'OK',
					  'error'
					);
				});
			this.dialogRef.close();
		}
	}

	onCloseClick() {
		this.dialogRef.close();
	}
}
